import { c as _c } from "react/compiler-runtime";
// `<OgDevError>` — dev-only error chip rendered on the card itself.
//
// Surface routes that fetch data should pass any caught error string into
// this primitive. In `NODE_ENV === 'development'`, the chip renders at
// the bottom of the card so the failure cause is visible without trawling
// dev terminal logs (e.g. "fetch: SdkError: Invalid gift opaque id").
// In every other build, the component returns `null` and is statically
// tree-shaken — production cards stay clean.
//
// Use this whenever a route renders a fallback because data couldn't be
// fetched. Pair it with the standard `{ data, errorDetail }` shape:
//   const { data, errorDetail } = await fetchSomething(id);
//   return data === null
//     ? <FallbackContent />     // your designed empty state
//     : <DataContent data={data} />;
// …and inside `<FallbackContent>` add `<OgDevError detail={errorDetail} />`.

import type { JSX } from 'react';
import { OG_TOKENS } from '../tokens';
import { isAuditSuppressed } from './audit-mode';
const IS_DEV: boolean = process.env.NODE_ENV === 'development';
export interface OgDevErrorProps {
  /** Error string to render. When `null` or in non-dev builds, returns null. */
  detail: string | null;
}
export function OgDevError(props) {
  const $ = _c(3);
  if (!IS_DEV) {
    return null;
  }
  if (isAuditSuppressed()) {
    return null;
  }
  if (props.detail === null) {
    return null;
  }
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      display: "flex",
      marginTop: 32,
      padding: "8px 18px",
      background: "rgba(239, 68, 68, 0.18)",
      color: OG_TOKENS.danger500,
      fontSize: 18,
      borderRadius: 8,
      maxWidth: 1000
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props.detail) {
    t1 = <div style={t0}>DEV — {props.detail}</div>;
    $[1] = props.detail;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}